import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Button';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

import Info from '../../svg/icons/ic_info-outline_20x20.svg';

import './InfoTooltip.scss';

const InfoTooltip = ({
  content, ariaLabel = '',
}) => (
  <Tooltip content={content} placement="bottom" theme="light">
    <Button className="InfoTooltip" variant="no-style" aria-label={ariaLabel}>
      <Icon component={Info} name="info" />
    </Button>
  </Tooltip>
);

InfoTooltip.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf([
      PropTypes.element,
    ]),
  ]).isRequired,
  ariaLabel: PropTypes.string,
};

InfoTooltip.defaultProps = {
  ariaLabel: 'Info tooltip button',
};

export default InfoTooltip;
